const COLORS = {
  1: '#FF3B3B',
  2: '#0087A3',
  3: '#FF7A00',
  4: '#7C22B8',
  5: '#E6AE00',
  6: '#4B34B8',
  7: '#5FC200',
  8: '#B8327C',
  9: '#00D468',
  10: '#1E4FB8',
  11: '#FF4FB3',
  12: '#B64B00',
  13: '#2F7DFF',
  14: '#3E8F00',
  15: '#7A5CFF',
  16: '#9A6F00',
  17: '#C93CFF',
  18: '#00994A',
  19: '#00D4FF',
  20: '#B72222'
}


export const getPreviewBackgroundColor = (index: number): string => {
  if (index <= 0 || index > 20) return '#3E8F00';
  return COLORS[index as keyof typeof COLORS];
}